import { DmsTypeOptions } from "@dms/configs/constants";

export const checkIsGroupType = (key: string) => {
    return DmsTypeOptions.find(el => el.value === key)?.isGroup;
};
